import { rememberConfirmedContact } from './propertySaveStorage';
import { HONEYPOT_FIELD_NAME } from '../components/HoneypotField';
import { requestLeadVerification, isLeadVerificationRequired } from './turnstileService';

const CHAT_LEADS_URL = 'https://tophamtechbe.com/api/treas/idx/v1/chatleads';
const API_KEY = 'treas-api-key-2025';

const createSuppressedLeadResponse = () => {
  const payload = { accepted: true };
  return {
    ok: true,
    status: 200,
    statusText: 'OK',
    honeypotBlocked: true,
    json: async () => payload,
    clone: createSuppressedLeadResponse
  };
};

const toSearchParams = (values) => {
  if (values instanceof URLSearchParams) return values;

  const params = new URLSearchParams();
  Object.entries(values || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null) params.set(key, value);
  });
  return params;
};

const requestChatLeads = async (values, method) => {
  const params = toSearchParams(values);
  if (method === 'POST' && params.get(HONEYPOT_FIELD_NAME)?.trim()) {
    console.info('Lead submission suppressed by spam protection.');
    return Promise.resolve(createSuppressedLeadResponse());
  }

  const headers = { 'X-API-Key': API_KEY };
  if (method === 'POST' && await isLeadVerificationRequired(params.get('siteId'))) {
    headers['X-Turnstile-Token'] = await requestLeadVerification();
  }
  return fetch(`${CHAT_LEADS_URL}?${params}`, {
    method,
    headers
  });
};

export const submitChatLead = async (values, { rememberContact = false } = {}) => {
  const response = await requestChatLeads(values, 'POST');
  if (rememberContact && response.ok && !response.honeypotBlocked) {
    try {
      const lead = await response.clone().json();
      rememberConfirmedContact(Object.fromEntries(toSearchParams(values)), lead);
    } catch { /* A later save can confirm the lead through the lookup endpoint. */ }
  }
  return response;
};
export const getChatLeads = (values) => requestChatLeads(values, 'GET');
